function a(t) {
  return this.__data__.get(t);
}
export {
  a as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_stackGet.js
// module id = 1551
// module chunks = 67